<template>
  <li class="suite-menu" :class="{hovered: isHover}" @mouseenter="handleEnter" @mouseleave="handleLeave">
    <a href="#" :class="{currentPromote: !!active, current: !!active}" @click="gotoSearch">{{$t('topbar.menu.suites').toUpperCase()}}</a>
    <div class="suite-sub-menu">
      <div class="sub-menu">
        <ul id="nossuites" :style="columnStyle">
          <li v-for="(zone, zoneIndex) in roomZones" :item="zone" :index="zoneIndex" :key="zone.name"
              class="li-zone">
            <div class="zone-header cursor primary-hover" @click="selectZone(zone.id)">
              <img :src="zone.icon" class="zone-icon"/>
              <h3 class="cursor primary-hover">{{zone.name}}</h3>
            </div>
            <div class="scrollable-wrapper with-scrollbar">
              <div class="catsuites" v-for="(group, groupIndex) in zone.room_groups" :item="group"
                   :index="groupIndex"
                   :key="group.text.name">
                <p class="cat cursor primary-hover" @click="selectGroup(zone.id, group.id)">{{group.text.name}}</p>
                <a @click="redirectToRooms(room.id, room.text.short_name)" class="suite"
                   v-for="(room, roomIndex) in group.rooms" :item="room" :key="room.name" :index="roomIndex">
                  {{room.text.short_name}} <span class="fg-primary" v-if="room.label && room.label.short">- {{room.label.short}}</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script>
  import {mapState} from 'vuex';
  import {TextHelper} from "../../helpers/text.helper";

  export default {
    name: 'suites-menu',
    props: ['active'],
    data() {
      return {
        isHover: false,
      }
    },
    computed: {
      ...mapState({
        instagram: s => s.menu.instagram,
        articles: s => s.menu.blogArticles,
        roomZones: s => s.menu.roomZones,
      }),
      columnStyle() {
        return `grid-template-columns: repeat(${this.roomZones.length}, 1fr);`
      }
    },
    methods: {
      async gotoSearch () {
        this.$store.commit('search/SET_SEARCH_ZONE', null);
        this.$store.commit('search/SET_SEARCH_GROUP', []);
        return this.redirect();
      },
      async redirect (keepGroups = false) {
        if (this.$route.name === 'search') {
          this.$store.commit('search/AUTO_FILL');
          await this.$store.dispatch('search/process', {keepGroups: keepGroups, runAuto: true});
          return;
        }
        await this.$router.push({name: 'search', params: {runAuto: true}});
      },
      async selectZone(id) {
        this.$store.commit('search/SET_SEARCH_ZONE', id);
        return this.redirect();
      },
      async selectGroup(zone, id) {
        this.$store.commit('search/SET_SEARCH_ZONE', zone);
        this.$store.commit('search/SET_SEARCH_GROUP', [id]);
        return this.redirect(true);
      },
      slug(v) {
        return TextHelper.slugify(v);
      },
      handleEnter () {
        this.isHover = true;
      },
      handleLeave() {
        this.isHover = false;
      },
      redirectToRooms(id, slug) {
        this.handleLeave();
        this.$router.push({name: "room", params: {id: id, slug: this.slug(slug)}}).catch(err => {});
      },
    }
  };
</script>

<style scoped>
  .notActive {
    pointer-events: none;
  }
  .cursor {
    cursor: pointer!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/topbar/suites-menu.vue